const prefix = "LEVY_COLLECTION_PROVIDER_";

export const DISMISS_SAP_RECONCILIATION_WARNING = prefix + "DISMISS_SAP_RECONCILIATION_WARNING";
export const EXISTS = prefix + "EXISTS";
export const EXPORT = prefix + "EXPORT";
export const FAVOURITE_QUIETLY = prefix + "FAVOURITE_QUIETLY";
export const FINALISE_GET = prefix + "FINALISE_GET";
export const FINALISE_SAVE = prefix + "FINALISE_SAVE";
export const GET_STATUS_HISTORY = prefix + "GET_STATUS_HISTORY";
export const GET_TIMELINE = prefix + "GET_TIMELINE";
export const IN_SCOPE_PREVIEW_GET = prefix + "IN_SCOPE_PREVIEW_GET";
export const IN_SCOPE_PREVIEW_REFRESH = prefix + "IN_SCOPE_PREVIEW_REFRESH";
export const ASSIGNED_PAYMENT_STATUS_SAVE = prefix + "ASSIGNED_PAYMENT_STATUS_SAVE";
export const LIST = prefix + "LIST";
export const LIST_FOR_PROVIDER = prefix + "LIST_FOR_PROVIDER";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const LIST_REFRESH = prefix + "LIST_REFRESH";
export const TASK_GET_PROVIDERS = prefix + "TASK_GET_PROVIDERS";
export const TASK_RUN = prefix + "TASK_RUN";
export const TASK_RUN_WITH_EXPLANATION = prefix + "TASK_RUN_WITH_EXPLANATION";
export const TASK_RUN_WITH_DUE_DATE = prefix + "TASK_RUN_WITH_DUE_DATE";
export const TASK_RUN_FINISH_UP = prefix + "TASK_RUN_FINISH_UP";
export const TASK_RUN_QUIETLY = prefix + "TASK_RUN_QUIETLY";
export const TASKS_GET = prefix + "TASKS_GET";
export const TASKS_REFRESH = prefix + "TASKS_REFRESH";
export const UPLOAD_GET_TEMPLATE = prefix + "UPLOAD_GET_TEMPLATE";
export const UPLOAD_SPREADSHEET = prefix + "UPLOAD_SPREADSHEET";
export const VIEW = prefix + "VIEW";
export const VIEW_REFRESH = prefix + "VIEW_REFRESH";
export const WARNINGS_GET = prefix + "WARNINGS_GET";
export const WARNINGS_REFRESH = prefix + "WARNINGS_REFRESH";
